import { useQuery } from '@tanstack/react-query';
// utils
import { AccountAPI } from '@newo/api/gateway';
import axiosInstance from '@/utils/api/axiosInstance.ts';

const accountAPI = new AccountAPI(axiosInstance);

export const useAccountQuery = (isEnabled = true) =>
    useQuery({
        queryKey: ['account'],
        enabled: isEnabled,
        queryFn: accountAPI.getAccount
    });
